export const getDefaultState = () => {
  return {
    orderBackup: {},
    calculatorData: {
      currentOrder: {
        // nessasry for PDF
        elementForm: '',
        imgPathforPDF: '',
        dripEdgeProfile: 0,
        wallProfiles: '',
        vacuumPanels: '',
        profilColor: '',
        a: 0,
        a1: 0,
        a2: 0,
        totalLength: 0,
        totalElements: 1,
        b: 0,
        e: 0,
        d1: 0,
        d2: 0,
        c: 0,
        g: 0,
        f: 0,

        // nessasry for Calculator
        isBox: false,
        insulationMaterial: '',
        h: 0,
        w: 0,
        totalLengthOfOneElement: 0,
        notches: ''
      },
      initValues: {
        // nessasry for PDF
        elementForm: '',
        imgPathforPDF: '',
        dripEdgeProfile: 0,
        wallProfiles: '',
        vacuumPanels: '',
        profilColor: '',
        a: 0,
        a1: 0,
        a2: 0,
        totalLength: 0,
        totalElements: 1,
        b: 0,
        e: 0,
        d1: 0,
        d2: 0,
        c: 0,
        g: 0,
        f: 0,

        // nessasry for Calculator
        isBox: false,
        insulationMaterial: '',
        h: 0,
        w: 0,
        totalLengthOfOneElement: 0,
        notches: ''
      },

      allowStepUpTo: 0,
      currentPageNumber: 0,
      tinyLink: '',
      base64Link: '',
      merchandiserViewToggleState: 0,
      contactToggleState: 0,
      calculatorPages: [
        {
          step: '1',
          stepNumber: 0,
          headline: 'insulationMaterial',
          inputFields: [
            { fieldName: 'insulationMaterial', didInput: false }
          ],
          disabled: false,
          allFieldsUpdated: false,
          errors: false,
          warnings: []
        },
        {
          step: '2',
          stepNumber: 1,
          headline: 'elementForm',
          inputFields: [
            { fieldName: 'elementForm', didInput: false }
          ],
          disabled: true,
          allFieldsUpdated: false,
          errors: false,
          warnings: []
        },
        {
          step: '3',
          stepNumber: 2,
          headline: 'elementLengths',
          inputFields: [
            { fieldName: 'a', didInput: false, min: 0, default: 0, steps: 1 },
            { fieldName: 'a1', didInput: false, min: 0, max: 0, default: 0, steps: 1 },
            { fieldName: 'a2', didInput: false, min: 0, max: 0, default: 0, steps: 1 },
            { fieldName: 'totalLength', didInput: false, default: 0 }
          ],
          disabled: true,
          allFieldsUpdated: false,
          errors: false,
          warnings: []
        },
        {
          step: '4',
          stepNumber: 3,
          headline: 'elementHeights',
          inputFields: [
            { fieldName: 'c', didInput: false, min: 0, max: 0, default: 0, steps: 1 },
            { fieldName: 'd1', didInput: false, min: 0, max: 0, default: 0, steps: 1 },
            { fieldName: 'd2', didInput: false, min: 0, max: 0, default: 0, steps: 1 }
          ],
          disabled: true,
          allFieldsUpdated: false,
          errors: false,
          warnings: []
        },
        {
          step: '5',
          stepNumber: 4,
          headline: 'elementWidths',
          inputFields: [
            { fieldName: 'e', didInput: false, min: 0, max: 0, default: 0, steps: 1 },
            { fieldName: 'b', didInput: false, min: 0, max: 0, default: 0, steps: 1 },
            { fieldName: 'w', didInput: false, min: 0, max: 0, default: 0, steps: 1 },
            { fieldName: 'h', didInput: false, min: 0, max: 0, default: 0, steps: 1 }
          ],
          disabled: true,
          allFieldsUpdated: false,
          errors: false,
          warnings: []
        },
        {
          step: '6',
          stepNumber: 5,
          headline: 'vacuumPanels',
          inputFields: [
            { fieldName: 'vacuumPanels', didInput: false, default: 0 }
          ],
          disabled: true,
          allFieldsUpdated: false,
          errors: false,
          warnings: []
        },
        {
          step: '7',
          stepNumber: 6,
          headline: 'notches',
          inputFields: [
            { fieldName: 'notches', didInput: false },
            { fieldName: 'f', didInput: false, min: 0, max: 0, default: 0, steps: 1 },
            { fieldName: 'g', didInput: false, min: 0, max: 0, default: 0, steps: 1 }
          ],
          disabled: true,
          allFieldsUpdated: false,
          errors: false,
          warnings: []
        },
        {
          step: '8',
          stepNumber: 7,
          headline: 'profiles',
          inputFields: [
            { fieldName: 'wallProfiles', didInput: false },
            { fieldName: 'profilColor', didInput: false },
            { fieldName: 'dripEdgeProfile', didInput: false }
          ],
          disabled: true,
          allFieldsUpdated: false,
          errors: false,
          warnings: []
        },
        {
          step: '9',
          stepNumber: 8,
          headline: 'summary',
          inputFields: [],
          disabled: true,
          errors: false,
          warnings: []
        }
      ],
      errors: false,
      warnings: []
    }
  }
}
